import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import ImagePickerField from './ImagePickerField/ImagePickerField'
import { FormattedMessage } from 'react-intl'
import { apiBlob } from 'helpers/decorators/api'
import { notification } from 'redux/modules/app'

@connect(
  ({ auth }) => ({
    user: auth.user
  }),
  { notification }
)
@apiBlob()
class ImagePicker extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    isFile: PropTypes.bool,
    intlKey: PropTypes.string,
    notification: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string.isRequired
  }

  render() {
    const { label, name, intlKey, disabled, isFile } = this.props
    const classNames = ['control-label']

    disabled && classNames.push('control-label-disabled')
    return (
      <div className="form-group">
        <label htmlFor={name} className={classNames.join(' ')}>
          {intlKey
            ? <FormattedMessage id={intlKey} defaultMessage={label} />
            : label}
        </label>
        <Field
          {...this.props}
          {...this.state}
          id={name}
          name={name}
          component={ImagePickerField}
          isFile={isFile}
          notification={this.props.notification}
        />
      </div>
    )
  }
}

export default ImagePicker
